import { Typography, TypographyProps } from "@mui/material";
import type { SystemProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import { mergeSx, splitSystemProps } from "@/utils/system-props";

type CustomTitleProps = {
  children: ReactNode;
  size?: string | number;
  bold?: boolean;
} & TypographyProps &
  SystemProps<Theme>;

const CustomTitle = ({
  children,
  bold,
  size,
  sx,
  ...others
}: CustomTitleProps) => {
  const { systemSx, rest } = splitSystemProps(others);
  return (
    <Typography
      {...rest}
      sx={mergeSx(
        {
          fontWeight: bold ? "bold" : "medium",
          ...(size ? { fontSize: size } : {}),
          ...systemSx,
        },
        sx
      )}
    >
      {children}
    </Typography>
  );
};

export default CustomTitle;
